import { DeviceSource } from '~/constants/common/DeviceSource';
import type { DeviceType, NativeDeviceType } from '~/contracts/common';

export type ScreenSize = {
  height: number;
  width: number;
};

export type DeviceTypeProps = {
  browserName: string;
  deviceName: string;
  deviceType: DeviceType;
  isBot: boolean;
  nativeDeviceType: NativeDeviceType;
};

export const defaultDeviceType: DeviceTypeProps = {
  browserName: '',
  deviceName: '',
  deviceType: {
    devicePixelRatio: 1,
    isDesktop: false,
    isLandscape: false,
    isLargeDesktop: false,
    isMobile: true,
    isMobileWithOrientation: true,
    isPortrait: true,
    isTablet: false,
    source: DeviceSource.UserAgentString
  },
  isBot: false,
  nativeDeviceType: {
    isNative: false,
    platform: null
  }
};
